export default __webpack_public_path__ + "static/media/benz-box.a9aa68ef.png";